<template>
  <div class="cf-card cf-flex cf-flex--row cf-flex--align-start cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
      <h3 class="cf-title cf-title--3">
        Gift Points
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        Transfer some of your points to a friend or family member.
      </p>
    </div>

    <button
      class="cf-button cf-button--primary cf-button--md cf-button--mobile-fill cf-align-self-center"
      type="button"
      @click="$openModal('giftingPointsModal')"
    >
      {{ pointsGifitingCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'GiftLoyaltyPointsCta',

    computed: {
      ...mapGetters('content', ['content']),

      pointsGifitingCta() {
        return this.content.Loyalty.metadata.giftPointsButtonCta;
      }
    }
  };
</script>
